export default "/images/vendor/flag-icon-css/flags/4x3/cx.svg?b7e461d75f0be7e9609da1f0d27ed4b6";